import { DatadogEventProcessor } from ".";
import {
  sendgridApiHosts as defaultSendgridApiHosts,
  httpResourceTypes,
} from "../../redaction/constants";
import {
  redactPathParams,
  redactSpecificAPIPathParams,
  redactSpecificViewPathParams,
} from "../../redaction/redactPathParams";

export function createRedactUrlPathParams(
  sendgridApiHosts = defaultSendgridApiHosts
): DatadogEventProcessor {
  return (event) => {
    if (event.type === "resource") {
      const { host } = new URL(event.resource.url);
      const shouldRedactPathParams =
        httpResourceTypes.includes(event.resource.type) && sendgridApiHosts.includes(host);

      if (shouldRedactPathParams) {
        event.resource.url = redactPathParams(event.resource.url);
        event.resource.url = redactSpecificAPIPathParams(event.resource.url);
      }
    }

    if (event.type === "view") {
      event.view.url = redactPathParams(event.view.url);
      event.view.url = redactSpecificViewPathParams(event.view.url);
    }
  };
}

export const redactUrlPathParams = createRedactUrlPathParams();
